<template>
  <div class="fillin">
    <div class="head-wrapper">
      <header class="head">
        <a class="logo-wrapper" href="/">
          <img src="./logo.png" alt="logo" width="180" height="40">
        </a>
        <a href="/" tag="div" class="back">返回首页</a>
      </header>
    </div>
    <div class="content">
      <h2 class="title">完善资料</h2>
      <p class="hint-title">（带有*，均为必填项）</p>
      <div class="row">
        <span class="left">学生姓名：</span>
        <input type="text"
               class="input-box" v-model="uname"
               placeholder="请填写姓名"
               maxlength="18">
        <span class="hint">*</span>
      </div>
      <div class="row">
        <span class="left">设置密码：</span>
        <input type="password"
               class="input-box" v-model="password"
               placeholder="请输入6-18位字符"
               maxlength="18">
        <span class="hint">*</span>
      </div>
      <div class="row">
        <span class="left">确认密码：</span>
        <input type="password"
               class="input-box"
               v-model="confirmPass"
               maxlength="18">
        <span class="hint">*</span>
      </div>
      <button class="next-btn" @click="register">完善资料</button>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal, saveSession, loadSession} from 'common/js/store.js';
  import md5 from 'js-md5'
  export default{
    data(){
      return {
        id: (() => loadSession('tempid', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        uname: '',
        password: '',
        confirmPass: '',
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      register(){
        if (this.uname === '') {
          this.$message({
            message: '请输入学生姓名',
            type: 'warning'
          });
          return;
        }
        if (this.password === '' || this.password.length < 6 || this.password.length > 18) {
          this.$message({
            message: '请输入6-18位字符密码',
            type: 'warning'
          });
          return;
        }
        if (md5(this.password) !== md5(this.confirmPass)) {
          this.$message({
            message: '两次输入的密码不一致',
            type: 'warning'
          });
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'updateuser',
            id: this.id,
            uname: this.uname,
            identity:2,      //老师为1，学生为2
            password:md5(this.password)
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.userinfo();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      userinfo(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'userinfo',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('id', this.id);
            saveLocal('userinfo', response);
            window.location.replace('/');
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      }
    },
    created(){

    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  body, html
    background: #f2f2f2
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .fillin
    padding-bottom: 20px
    .head-wrapper
      background #fff
      border-bottom: 1px solid #efefef;
      box-shadow: 0 0 10px 2px #fafafa;
      .head
        width: 1000px
        height: 60px
        margin: 0 auto
        background: #fff
        font-size: 0
        .logo-wrapper
          display: inline-block;
          width: 180px;
          height: 40px;
          padding-top: 10px;
        .back
          margin-right: 10px
          float: right
          height: 60px
          line-height: 60px
          font-size: 14px
          color: #666666
          cursor pointer
    .content
      margin: 30px auto 0
      font-size: 0
      width: 1000px
      padding-bottom: 75px
      background: #fff
      .title
        padding-top: 45px;
        height: 35px
        line-height: 35px
        text-align: center
        font-size: 28px
        color: #000000
        font-weight: bold
      .hint-title
        margin-bottom: 52px
        height: 18px
        line-height: 18px
        text-align: center
        font-size: 13px
        color: #ff0000
      .row
        margin: 0 0 10px 265px
        .left
          display: inline-block
          margin-right: 10px
          width: 104px
          height: 50px
          line-height: 50px
          color: #000000
          font-size: 16px
          text-align: right
          vertical-align top
        .input-box
          padding-left: 15px
          width: 330px
          height: 50px
          font-size: 16px
          color: #000
          border: 1px solid #d7d7d7
          border-radius: 4px
          box-sizing: border-box
          &::-webkit-input-placeholder
            color: #ccc
        .hint
          position: relative
          top: 6px
          display: inline-block
          margin-left: 5px
          height: 30px
          line-height: 30px
          font-size: 14px
          color: #ff3300
        .send, .time
          display: inline-block
          margin-left: 10px
          width: 80px
          height: 30px
          line-height: 30px
          text-align: center
          font-size: 12px
          border-radius: 4px
        .send
          background: #ffd222
          color: #6f4605
          cursor: pointer
        .time
          background: #f2f2f2
          color: #666
      .next-btn
        margin: 70px auto 0
        display: block
        width: 150px
        height: 48px
        line-height: 48px
        text-align: center
        font-size: 20px
        color: #ffffff
        background #3399ff
        border-radius: 4px
      .split
        margin: 30px auto
        width: 520px
        font-size: 0
        border-bottom: 1px dashed #e4e4e4
</style>



// WEBPACK FOOTER //
// src/page/register/FillinStudent.vue